// src/assets/mockdata/Lab/labData.ts
import { Laboratory, LabOrder } from '@dataTypes/lab.types'

export const labOrders: LabOrder[] = [
  {
    orderNo: 'LAB-001',
    requestedOn: '2025-04-21',
    patientName: 'Jane Doe',
    providerName: 'Dr. Emily Smith',
    partnerLabName: 'Smile Labs',
    dueDate: '2025-05-01',
    priority: 'Normal',
    totalAmount: 250.0,
    description: 'Crown - Molar',
    completionDate: '2025-04-24',
    status: 'Pending',
    prescriptions: [
      {
        procedureType: 'Crown',
        region: 'Upper Right Molar',
        material: 'Porcelain',
        shadeNo: 'A2',
        instructions: 'Use digital impression',
      },
    ],
    attachments: [
      {
        fileName: 'scan1.jpg',
        fileType: 'jpg',
        dateTaken: '2025-04-20',
      },
    ],
    labWorkType: 'Prosthodontics',
  },
  {
    orderNo: 'LAB-002',
    requestedOn: '2025-04-20',
    patientName: 'John Smith',
    providerName: 'Dr. William Johnson',
    partnerLabName: 'OralCare Lab',
    dueDate: '2025-04-28',
    priority: 'Urgent',
    totalAmount: 180.0,
    description: 'Bridge - Incisor',
    completionDate: '2025-04-22',
    status: 'Completed',
    prescriptions: [
      {
        procedureType: 'Bridge',
        region: 'Lower Left Incisor',
        material: 'Zirconia',
        shadeNo: 'B1',
        instructions: 'Patient allergic to metal',
      },
    ],
    attachments: [
      {
        fileName: 'xray2.png',
        fileType: 'png',
        dateTaken: '2025-04-18',
      },
    ],
    labWorkType: 'Prosthodontics',
  },
]

export const laboratories: Laboratory[] = [
  {
    id: '1',
    name: 'Smile Dental Lab',
    phoneNumber: '123-456-7890',
    address: '123 Main St, Cityville',
    email: 'contact@smilelab.com',
    isActive: true,
    services: [
      { type: 'Crowns', turnaroundDays: '3 days', expedite: 'Yes (2 Days)' },
      { type: 'Dentures', turnaroundDays: '5 days', expedite: 'No' },
      { type: 'Bridges', turnaroundDays: '4 days', expedite: 'Yes (3 Days)' },
    ],
    notes: 'Reliable partner for over 5 years',
  },
  {
    id: '2',
    name: 'BrightSmile Labs',
    phoneNumber: '987-654-3210',
    address: '456 Oak Ave, Townsville',
    email: 'info@brightsmile.com',
    isActive: false,
    services: [
      {
        type: 'Mouthguards',
        turnaroundDays: '2 days',
        expedite: 'Yes (1 Day)',
      },
      { type: 'Veneers', turnaroundDays: '6 days', expedite: 'No' },
    ],
    notes: 'Specializes in sports mouthguards',
  },
]
